







































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import AppLifeCycle from "@/utils/app_lifecycle/app_lifecycle";

@Component({
  components: { swiper, swiperSlide }
})
export default class SpecialHeader extends Vue {
  @Prop({ default: true })
  private singleDiscount!: boolean;
  @Prop({ default: true })
  private offerDiscount!: boolean;
  @Prop({ default: 300 })
  private time!: number;
  private foregroundListener: any = null;
  private timer: any = null;
  private interval: any = null;
  private timeSpanStyle =
    "width:40px;height:22px;display:flex;justify-content:center;align-items:center;border-radius:11px;color:rgb(255,75,32);background:rgb(245,246,250);margin:2px;";
  private specelText =
    '<span style="font-size:16px;font-family:Poppins, AppleSDGothicNeo-Medium">Special Offer Today</span>';
  private textList: any = "";
  private hour: string | number = "";
  private min: string | number = "";
  private sec: string | number = "";

  private swiperOptions = {
    direction: "vertical",
    loop: true,
    autoplay: {
      delay: 5000
    },
    observer: true,
    observeParents: false,
    initialSlide: 0
  };

  @Watch("time", { immediate: true })
  private timeChange(val: number, oldVal: number) {
    console.log("time===", val, oldVal);
    // this.getTextList();
    if (val !== oldVal && (!oldVal || val - oldVal >= 1000)) {
      this.triggerCountDown(val);
    }
  }

  private removeCountDownListener() {
    if (this.foregroundListener !== null) {
      AppLifeCycle.removeListener(this.foregroundListener);
    }
  }

  private addCountDownListener() {
    if (!this.foregroundListener) {
      this.foregroundListener = AppLifeCycle.addFrontListener(() => {
        this.triggerCountDown(this.time);
      });
    }
  }

  private clearTimerAndListener() {
    this.removeCountDownListener();
    clearInterval(this.timer);
  }

  private triggerCountDown(endTimeStamp: any) {
    const nowTime = new Date().valueOf();
    const time = Math.round((endTimeStamp - nowTime) / 1000);
    if (time > 0) {
      this.startCountDown(time);
    } else {
      this.$emit("countDownTimeEnded");
      this.clearTimerAndListener();
    }
  }

  private startCountDown(time: any) {
    this.clearTimerAndListener();
    // this.getTimeStr(time);
    this.getTextList(time);
    this.addCountDownListener();
    this.timer = setInterval(() => {
      time--;
      if (time > 0) {
        // this.getTimeStr(time);
        this.getTextList(time);
        this.$emit("countingDown", time); // 新增一个countingDown事件返回
      } else {
        this.$emit("countDownTimeEnded");
        this.clearTimerAndListener();
      }
    }, 1000);
  }

  private getTimeStr(time: number) {
    let hour: number | string = Math.floor(time / 3600);
    hour = this.addZero(hour);
    let min: number | string = 0;
    let sec: number | string = Math.round(time % 60);
    sec = this.addZero(sec);
    min = Math.floor((time % 3600) / 60);
    min = this.addZero(min);
    return {
      hour,
      min,
      sec
    };
  }

  private addZero(num: number) {
    return num < 10 ? "0" + num : num;
  }

  private getTextList(param: any) {
    const { hour, min, sec } = this.getTimeStr(param);
    // console.log("getTextList", {
    //   param, hour, min, sec
    // })
    // this.textList = [
    //   this.specelText,
    //   `<span style=${this.timeSpanStyle}>${hour}</span>
    //   :<span style=${this.timeSpanStyle}>${min}</span>
    //   :<span style=${this.timeSpanStyle}>${sec}</span>
    //   `
    // ]
    // this.textList = `<span style=${this.timeSpanStyle}>${hour}</span>
    //   :<span style=${this.timeSpanStyle}>${min}</span>
    //   :<span style=${this.timeSpanStyle}>${sec}</span>`;
    this.textList = `${hour}:${min}:${sec}`;
    this.hour = hour;
    this.min = min;
    this.sec = sec;
  }

  private mounted() {
    this.triggerCountDown(this.time);
  }

  private activated() {
    this.triggerCountDown(this.time);
  }

  private beforeDestroy() {
    console.log("countDown beforeDestroy:", this);
    this.clearTimerAndListener();
  }

  private deactivated() {
    this.clearTimerAndListener();
  }
}
